import React from 'react';
import ProveedorForm from '../../components/Forms/ProveedorForm.jsx';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import Proveedor from '../../Models/Proveedor';
import ProveedoresActions from '../../reflux/ProveedoresActions';
import AlertActions from '../../reflux/AlertActions';
import ProveedorStore from '../../reflux/stores/ProveedorStore';
import Back from '../../components/Buttons/BackButton.jsx';
import Truck from '../../components/Buttons/TruckButton.jsx';
import Card from 'material-ui/Card';
import AuthActions from '../../reflux/AuthActions';
import AuthStore from '../../reflux/stores/AuthStore';
import Check from 'material-ui/svg-icons/action/check-circle';

export default class ProveedoresCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proveedor: new Proveedor({}),
            tipos_proveedor: [
                {
                    text: 'Personal Natural Residente',
                    codigo: 'PND',
                    label: function() { return this.text;},
                },
                {
                    text: 'Personal Juridica Domiciliada',
                    codigo: 'PJD',
                    label: function() { return this.text;},
                }
            ]
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.proveedorChange = this.proveedorChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    
    componentWillMount() {
        const cliente = AuthStore.getCliente();
        const back = (
            <Back onTouchTap={this.props.router.goBack}
                iconProps={{color:"white"}}/>
            );
            const Trucks = (
            <Truck 
                iconProps={{color:"white"}}/>
            );
        AlertActions.stopLoading();
        AlertActions.configureAppBar('Proveedores', back, Trucks);
        this.setState({proveedor: new Proveedor({cliente_id: cliente.id})});
    }

    componentDidMount() {
        this.unsubscribe = ProveedorStore.listen(this.proveedorChange);
        this.unsubscribeAuth = AuthStore.listen(this.proveedorChange);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    proveedorChange(e, proveedor) {
        if (e === 'postedProveedor') {
            const msg = <div>Proveedor Creado <Check color="green" /></div>;
            AlertActions.alert('open', msg, 'Ha creado satisfactoriamente al  proveedor '+proveedor.name+' con el R.I.F. '+proveedor.rif);
            this.props.router.push('proveedores');
        }

        if (e === 'getRif') {
            let proveedore = this.state.proveedor;

            proveedore.name = proveedor.nombre;
            proveedore.porcentaje_retencion = proveedor.porcentaje_retencion;

            this.setState({proveedor: proveedore});
        }
    }

    /**
     * Handle when one of the form input changes it's value
     * 
     * @param e Event (onChange)
     * 
     */
    handleInputChange(e) {
        if (e.target.name === 'tipo_proveedor') e.target.value = this.state.tipos_proveedor[e.target.value].codigo;
        let proveedor = this.state.proveedor.handleInputChange(e);
        this.setState({proveedor: proveedor});
    }

    handleSearch(rif, event) {
        AlertActions.startLoading();
        ProveedoresActions.getRif(rif);
    }

    handleSubmit(e) {
        ProveedoresActions.postProveedor(this.state.proveedor);
    }

    render() {
        return (
            <div className="retivacontainer">
            <Card style={{padding:'10px 20px 20px 20px', marginTop: 20}}>
                <h2 className="center">Datos del Proveedor</h2>
                <ProveedorForm 
                proveedor={this.state.proveedor}
                tipos_proveedor={this.state.tipos_proveedor}
                handleChange={this.handleInputChange}
                handleSearch={this.handleSearch} />
            </Card>
                <FloatingActionButton onTouchTap={this.handleSubmit} style={{position:'absolute', bottom:-70, right:15}}>
                        <ContentSave />
                </FloatingActionButton>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/Proveedores/ProveedoresCreate.jsx
 **/